import { MockHook } from '@jupiterone/jupiter-web-toolkit';
export interface AppsIconProps {
  className?: string;
}
const useAppsIconLogic = ({ className }: AppsIconProps) => {
  return {
    className,
  };
};

export type AppsIconComponentProps = ReturnType<typeof useAppsIconLogic>;
export const MOCK_APPS_ICON_PROPS: AppsIconComponentProps = {
  className: '',
};
export default MockHook.useMockHook(useAppsIconLogic, MOCK_APPS_ICON_PROPS);
